module.exports = __webpack_public_path__ + "img/trophy-three.03b63648.svg";